export enum ProductStatuses {
  STOCK = 3,
  ORDER = 4,
  OUT_OF_PRODUCTION = 7
}
